import { Stack } from '@material-ui/core';
import { Skeleton } from '@mui/material';
import React from 'react';

import { RepresentativesTabStyledContainer } from './StyledComponents';

function RepresentativesTabSkeleton() {
  return (
    <RepresentativesTabStyledContainer>
      <Stack spacing={'20px'} direction={'column'}>
        <Skeleton variant="rounded" width={'100%'} height={110} />
        <Skeleton variant="rounded" width={'100%'} height={110} />
        <Skeleton variant="rounded" width={'100%'} height={110} />
      </Stack>
    </RepresentativesTabStyledContainer>
  );
}

export { RepresentativesTabSkeleton };
